/* ============================================================
   KP ANALYTICS BEACON — the transport theme-analytics.js deliberately omits.

   Install as assets/kp-analytics-beacon.js and load it with defer, AFTER
   theme-analytics.js.

   Subscribes to the `kp:analytics` CustomEvent bus already emitted by
   theme-analytics.js and forwards batches to the first-party collector
   (/kpa/collect), which is a Cloudflare Worker on this domain. Server API
   secrets never appear here; the public GA4 web measurement ID is owned by
   kp-remarketing.js so it can create an attributed browser session.

   Human-intent gate: nothing is sent until the visitor produces a trusted
   input event, matching the existing pixel gate in layout/theme.liquid.
   Automated page loads therefore generate no analytics at all, which is the
   behaviour the merchant asked for ("fire only if i believe its not bot").
   Events raised before that point are queued, not discarded, so a genuine
   visitor's page_view is not lost.
   ============================================================ */
(function () {
  var storeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cfgEl = document.getElementById('kp-analytics-config');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.token || !cfg.ts) return;

  var MAX_QUEUE = 40;
  var FLUSH_MS = 4000;
  var queue = [];
  var released = false;
  var timer = null;

  /* client_id must be stable per browser for GA4 to stitch a session together,
     but it is not an identifier we choose or that identifies a person — a
     random value stored locally is exactly what gtag does. */
  function clientId() {
    try {
      var k = 'kp_cid';
      var v = localStorage.getItem(k);
      if (!v) {
        v = (Date.now() ^ (Math.random() * 1e9 | 0)).toString(36) + '.' +
            (Math.random() * 1e9 | 0).toString(36);
        localStorage.setItem(k, v);
      }
      document.cookie = "_kp_cid=" + v + "; path=/; max-age=" + (60 * 60 * 24 * 365) + "; SameSite=Lax; Secure";
      return v;
    } catch (e) {
      var fallback = 'nostore.' + (Math.random() * 1e9 | 0).toString(36);
      document.cookie = "_kp_cid=" + fallback + "; path=/; max-age=" + (60 * 60 * 24 * 365) + "; SameSite=Lax; Secure";
      return fallback;
    }
  }

  function sessionId() {
    try {
      var k = 'kp_sid';
      var v = sessionStorage.getItem(k);
      if (!v) {
        v = String(Math.floor(Date.now() / 1000));
        sessionStorage.setItem(k, v);
      }
      document.cookie = "_kp_sid=" + v + "; path=/; SameSite=Lax; Secure";
      return v;
    } catch (e) {
      var fallback = String(Math.floor(Date.now() / 1000));
      document.cookie = "_kp_sid=" + fallback + "; path=/; SameSite=Lax; Secure";
      return fallback;
    }
  }

  /* Prefer GA4's OWN identifiers when the Google tag has published them.
     ----------------------------------------------------------------------
     kp-remarketing.js configures GA4 and writes gtag's real client_id and
     session_id to _kp_ga_cid / _kp_ga_sid. Server events must carry those
     exact values, otherwise GA4 files them under a different user and they do
     not inherit the browser session's source/medium — which is the entire
     point of putting the tag back.

     Falls back to our own ids when the tag has not loaded yet (it waits for a
     trusted interaction). Those early events land unstitched, which is better
     than losing them. Re-read on every send, so once gtag loads mid-visit the
     rest of the session stitches correctly. */
  function gaCookie(n) {
    try {
      var m = document.cookie.match('(^|;\\s*)' + n + '=([^;]*)');
      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) { return ''; }
  }

  var CID = clientId();
  var SID = sessionId();
  var started = Date.now();

  /* PRISJAKT / PriceSpy click id (13 Aug 2026).
     Prisjakt appends ?pjclid=<uuid>_<sig> to the landing URL and attributes a
     purchase to that click for up to 30 DAYS. Shopify's own landing_site holds
     only the FIRST landing URL of a session, so it cannot carry a click made
     days earlier in an earlier session — hence a 30-day first-party cookie,
     mirrored into cart attributes below so the ORDER WEBHOOK (which reports the
     conversion server-side) receives it whenever the order is placed. */
  function prisjaktClickId() {
    try {
      var m = location.search.match(/[?&]pjclid=([^&#]+)/i);
      if (m && m[1]) {
        var v = decodeURIComponent(m[1]);
        document.cookie = '_kp_pjclid=' + encodeURIComponent(v) +
          '; path=/; max-age=' + (60 * 60 * 24 * 30) + '; SameSite=Lax; Secure';
        return v;
      }
      var c = document.cookie.match(/(?:^|;\s*)_kp_pjclid=([^;]+)/);
      return c ? decodeURIComponent(c[1]) : '';
    } catch (e) { return ''; }
  }
  var PJCLID = prisjaktClickId();

  /* GOOGLE CLICK ID -> CART ATTRIBUTE (24 Aug 2026).
     The checkout pixel reads attribution from the _kp_attr cookie, written
     with browser.cookie.set(name, value) - an API that takes no expiry and
     rejects attributes (an older build appended them to the VALUE, which is
     why readAttr() still carries a split(';') recovery). That cookie therefore
     cannot be given a lifetime, so a shopper who clicks the ad, closes the
     browser and buys days later reaches checkout with no gclid - even though
     Google's conversion window runs to 90 days.

     Same shape as the Prisjakt fix above and for the same reason: a 90-day
     first-party cookie mirrored into cart attributes, so the ORDER WEBHOOK
     gets the click id server-side whenever the order lands, with no
     dependence on the sandbox cookie surviving. */
  function googleClickId() {
    try {
      var m = location.search.match(/[?&](?:gclid|gbraid|wbraid)=([^&#]+)/i);
      if (m && m[1]) {
        var v = decodeURIComponent(m[1]);
        document.cookie = '_kp_gclid=' + encodeURIComponent(v) +
          '; path=/; max-age=' + (60 * 60 * 24 * 90) + '; SameSite=Lax; Secure';
        return v;
      }
      var c = document.cookie.match(/(?:^|;\s*)_kp_gclid=([^;]+)/);
      return c ? decodeURIComponent(c[1]) : '';
    } catch (e) { return ''; }
  }
  var GCLID = googleClickId();

  try {
    /* The guard carries the pjclid so a click arriving mid-session re-syncs
       once, instead of being locked out by an earlier plain sync. */
    var syncKey = (PJCLID ? 'pj:' + PJCLID : '1') + (GCLID ? '|g:' + GCLID : '');
    if (sessionStorage.getItem('kp_cart_synced') !== syncKey) {
      var cartAttrs = { _kp_cid: CID, _kp_sid: SID };
      if (PJCLID) cartAttrs._kp_pjclid = PJCLID;
      if (GCLID) cartAttrs._kp_gclid = GCLID;
      fetch(storeRoot + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: cartAttrs }),
        keepalive: true
      }).then(function(r) {
        /* fetch resolves for 404/422/429/500, so without this ok-check the
           "synced" marker was written for a request the server rejected, and
           the guard above then blocked every retry for the rest of the session
           - dropping _kp_cid/_kp_sid/_kp_pjclid, and with them the only route
           by which the order webhook learns about a click made in an earlier
           session. kp-remarketing.js:79-81 and kp-meta-pixel.js:65-67 both
           already guard; this was the odd one out. (23 Aug 2026) */
        if (!r || !r.ok) return;
        try { sessionStorage.setItem('kp_cart_synced', syncKey); } catch(e){}
      }).catch(function() {});
    }
  } catch (e) {}

  /* ------------------------------------------------------------------------
     Traffic source, on every page view.

     The Worker has always logged gclid/source/medium/referrer, but it reads
     them from `attribution`, and only the checkout pixel ever sent that — so
     every storefront row in the dashboard showed blank columns and there was
     no way to see where visitors came from. This computes the same first/last
     touch the pixel does, so page views carry their origin too.

     First touch is written once and never overwritten; last touch updates
     whenever a new signal arrives. A visitor arriving on an ad, browsing, then
     returning direct still shows the ad as first touch. Internal navigation
     carries no signal, so it inherits whatever is stored rather than
     overwriting the real source with "(direct)".
     ---------------------------------------------------------------------- */
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'epik', 'oppref', 'pjclid'];

  function currentTouch() {
    var q = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var i = p.indexOf('=');
      var k = decodeURIComponent(i < 0 ? p : p.slice(0, i)).toLowerCase();
      if (k) q[k] = i < 0 ? '' : decodeURIComponent(p.slice(i + 1).replace(/\+/g, ' ')).slice(0, 200);
    });
    var ref = document.referrer || '';
    var src = '', med = '';
    if (q.gclid || q.gbraid || q.wbraid) { src = 'google'; med = 'cpc'; }
    else if (q.msclkid) { src = 'bing'; med = 'cpc'; }
    else if (q.fbclid) { src = 'facebook'; med = 'paid_social'; }
    else if (q.ttclid) { src = 'tiktok'; med = 'paid_social'; }
    else if (q.utm_source) { src = q.utm_source; med = q.utm_medium || 'referral'; }
    else if (ref) {
      try {
        var h = new URL(ref).hostname.replace(/^www\./, '');
        if (h && h.indexOf('kneepillow.co.uk') === -1) {
          src = h;
          med = /google|bing|yahoo|duckduckgo|ecosia|brave/i.test(h) ? 'organic' : 'referral';
        }
      } catch (e) {}
    }
    if (!src) return null; /* no signal — do not overwrite a real source */
    var t = {
      source: src, medium: med,
      campaign: q.utm_campaign || '', term: q.utm_term || '', content: q.utm_content || '',
      referrer: ref.slice(0, 500),
      /* 1000 not 300: gclid sits at the end of Google Ads URLs and was being
         truncated off the stored landing that gtag now reads as page_location. */
      landing: location.href.slice(0, 1000),
      ts: Math.floor(Date.now() / 1000)
    };
    CLICK_IDS.forEach(function (k) { if (q[k]) t[k] = q[k]; });
    return t;
  }

  function persistTouch() {
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem('_kp_attr_web') || '{}'); } catch (e) {}
    var touch = currentTouch();
    if (touch) {
      if (!stored.first) stored.first = touch;
      stored.last = touch;
      try { localStorage.setItem('_kp_attr_web', JSON.stringify(stored)); } catch (e) {}
    }
    return stored;
  }
  /* Write first-touch BEFORE kp-remarketing.js runs (it is the next defer
     script). gtag config reads this when the current URL has already lost
     campaign params; waiting until the beacon POST is too late. */
  persistTouch();

  function attribution() {
    var stored = persistTouch();
    if (!stored.first && !stored.last) {
      /* Genuinely direct: record it so the dashboard shows "(direct)" rather
         than an empty cell that looks like a tracking failure. */
      stored.last = {
        source: '(direct)', medium: '(none)',
        referrer: '', landing: location.href.slice(0, 1000),
        ts: Math.floor(Date.now() / 1000)
      };
    }
    return stored;
  }

  /* ------------------------------------------------------------------------
     Automation signals.

     Collected in the browser, scored in the Worker — so thresholds can be
     tuned by redeploying the Worker rather than pushing the theme and waiting
     on asset caches. Deliberately NOT a third-party library (BotD and friends
     mean another CDN script on every page, which is what we just removed).

     Each is a contradiction a real device cannot produce:
       webdriver      - true under Puppeteer/Playwright/Selenium
       zeroScreen     - headless browsers frequently report 0x0
       noTouch        - a phone user agent with zero touch points
       noOuter        - outerWidth 0 means no real window chrome
       noLangs        - navigator.languages empty; every real browser has one
       swMesa         - WebGL renderer is SwiftShader/llvmpipe/Mesa, i.e.
                        software rendering, the default in headless Chrome
       noCores        - hardwareConcurrency 0
     Individually several are weak, so the Worker requires a combination.
     Purchases are exempt from the verdict, so no sale can be lost to a
     false positive.
     ---------------------------------------------------------------------- */
  function botSignals() {
    var f = {};
    try { if (navigator.webdriver === true) f.webdriver = 1; } catch (e) {}
    try { if (!screen.width || !screen.height) f.zeroScreen = 1; } catch (e) {}
    try {
      var ua = navigator.userAgent || '';
      if (/iPhone|iPad|Android|Mobile/i.test(ua) && !(navigator.maxTouchPoints > 0)) f.noTouch = 1;
      if (/Chrome\//.test(ua) && !/Edg\/|OPR\//.test(ua) && !window.chrome) f.noChrome = 1;
      if (/HeadlessChrome/i.test(ua)) f.headlessUA = 1;
    } catch (e) {}
    try { if (!window.outerWidth) f.noOuter = 1; } catch (e) {}
    try { if (!navigator.languages || !navigator.languages.length) f.noLangs = 1; } catch (e) {}
    try { if (navigator.hardwareConcurrency === 0) f.noCores = 1; } catch (e) {}
    try {
      var c = document.createElement('canvas');
      var gl = c.getContext('webgl') || c.getContext('experimental-webgl');
      if (gl) {
        var dbg = gl.getExtension('WEBGL_debug_renderer_info');
        var r = dbg ? String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) || '') : '';
        if (/swiftshader|llvmpipe|mesa offscreen/i.test(r)) f.swRender = 1;
      } else {
        f.noWebgl = 1;
      }
    } catch (e) {}
    return f;
  }

  function send(useBeacon) {
    if (!queue.length) return;
    var batch = queue.splice(0, queue.length);
    var payload = JSON.stringify({
      ts: cfg.ts,
      token: cfg.token,
      client_id: gaCookie('_kp_ga_cid') || CID,
      session_id: gaCookie('_kp_ga_sid') || SID,
      /* Did gtag ACTUALLY run on this pageview? kp-remarketing sets
         window.__kpGaLive only after gtag configured (past looksAutomated +
         consent). The Worker uses this — not the cid format — to decide whether
         it must open the GA4 session itself via /g/collect, which fixes the
         returning-visitor case where an old numeric cid survives but gtag was
         suppressed this visit. */
      ga_live: (window.__kpGaLive === 1 ? 1 : 0),
      /* 'input:scroll' / 'input:pointerdown' / ... = a real trusted gesture
         happened. 'dwell' = the page was visible 2.5s and NOTHING was touched. */
      release: releaseReason,
      /* DID A GTAG HIT ACTUALLY REACH GOOGLE? (21 Aug 2026, diagnostic only.)
         ga_live proves gtag.js LOADED, not that its page_view landed. A blocker
         that allows googletagmanager.com but blocks google-analytics.com leaves
         gtag apparently healthy while the session is never created — GA4 then
         shows the visit as "(not set)" with a BLANK landing page, because the
         only events it ever receives are the Worker's MP events. 29 such
         sessions on 21 Aug, against 17 Google ad clicks that had gtag's own cid.

         Resource Timing sees the collect request whatever transport gtag picks
         (fetch, XHR, image, sendBeacon are all reported). Timing is safe: this
         runs at flush, 2.5-6.5s after load, while gtag hits within ~1s of
         config — so an absent entry means blocked, not "too early".

         NOTHING BRANCHES ON THIS YET. It is logged so tomorrow's number is
         measured rather than argued: acting on a false positive would open a
         duplicate session for every healthy gtag visitor, which is worse than
         the hole it would close. */
      ga_hit: (function () {
        try {
          var es = performance.getEntriesByType('resource');
          for (var i = 0; i < es.length; i++) {
            if (/(^|\.)(google-analytics\.com|analytics\.google\.com)/.test(es[i].name)
                && /[\/.]collect/.test(es[i].name)) return 1;
          }
        } catch (e) { return -1; }   /* -1 = could not measure, not "blocked" */
        return 0;
      })(),
      attribution: attribution(),
      signals: botSignals(),
      events: batch
    });

    /* sendBeacon survives page unload, which plain fetch does not — that is
       what makes checkout_begin and outbound product_click reliable. */
    if (useBeacon && navigator.sendBeacon) {
      try {
        navigator.sendBeacon(cfg.endpoint, new Blob([payload], { type: 'application/json' }));
        return;
      } catch (e) { /* fall through to fetch */ }
    }
    try {
      fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
        credentials: 'omit'
      }).catch(function () {});
    } catch (e) {}
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; send(false); }, FLUSH_MS);
  }

  document.addEventListener('kp:analytics', function (e) {
    var d = e && e.detail;
    if (!d || !d.event) return;

    var params = {};
    Object.keys(d).forEach(function (k) {
      if (k === 'event') return;
      var v = d[k];
      if (v === undefined || v === null || v === '') return;
      params[k] = typeof v === 'number' || typeof v === 'boolean' ? v : String(v).slice(0, 100);
    });
    params.engagement_time_msec = Math.max(1, Date.now() - started);
    params.page_location = location.href.slice(0, 400);
    params.page_referrer = (document.referrer || '').slice(0, 400);
    /* Without page_title GA4's "Page title and screen class" report is entirely
       "(not set)" — 36 of 36 views on 5 Aug 2026. Measurement Protocol does not
       infer it from the URL, so it has to be sent. */
    params.page_title = (document.title || '').slice(0, 300);

    queue.push({ name: d.event, params: params });

    /* GA4's e-commerce reports key on view_item with an items array — a
       page_view carrying product context does not populate them, which is why
       other pixels emit a separate product-view event. Derive it here from
       the same bus event rather than asking the theme to fire twice. Items
       are keyed by SKU (merchant decision, matches Merchant Center). Built
       explicitly because the generic copier above flattens objects to
       strings, which would destroy the items array. */
    if (d.event === 'page_view' && d.page_type === 'product' && d.product_sku) {
      queue.push({
        name: 'view_item',
        params: {
          currency: String((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP'),
          value: parseFloat(d.product_price || '0') || 0,
          items: [{ item_id: String(d.product_sku).slice(0, 100), price: parseFloat(d.product_price || '0') || 0, quantity: 1 }],
          page_location: location.href.slice(0, 400),
          page_title: (document.title || '').slice(0, 300)
        }
      });
    }

    if (queue.length > MAX_QUEUE) queue.splice(0, queue.length - MAX_QUEUE);
    if (released) schedule();
  });

  /* Dwell gate — not an interaction gate.
     ----------------------------------------------------------------------
     The original gate required a trusted click/scroll before anything was
     sent. That filtered bots as a side effect but also erased every real
     visitor who lands, reads and leaves without touching the page, which is
     why GA4 showed a fraction of true traffic.

     Removing it let scrapers in: they render the page, take the product data
     and leave, producing page_view + view_item and nothing else — no
     product_click, no variant_change, no search, no cart. That is exactly the
     pattern the merchant identified on 5 Aug 2026.

     So the gate is now TIME, not interaction. A scraper loads and leaves in
     well under a second; a person reading a product page is still there after
     two and a half. Whichever comes first releases the queue:
       - a trusted input event (fast path for someone who clicks immediately)
       - or 2.5s of the page actually being visible

     Time spent in a background tab does not count, so a prefetched or
     preloaded page never releases on its own. Nothing is discarded while
     waiting — events queue and flush on release, so a real visitor's page_view
     is never lost, only delayed.

     navigator.webdriver is checked first: it is true under Puppeteer,
     Playwright and Selenium, and most scrapers never bother to hide it.
     ---------------------------------------------------------------------- */
  try { if (navigator.webdriver === true) return; } catch (e) {}

  var DWELL_MS = 2500;
  var visibleSince = document.visibilityState === 'visible' ? Date.now() : 0;
  var dwelled = 0;
  var dwellTimer = null;

  /* WHICH PATH RELEASED THE QUEUE (23 Aug 2026).
     The gate opens on EITHER a trusted input event OR 2.5s of visible dwell,
     and until now nothing recorded which. That single bit is the difference
     between "a person looked at this page" and "something rendered it and
     left", and it is the exact question the merchant is asking about paid
     clicks that produce page_view + view_item and nothing else. Recorded, not
     acted on: this changes no gating and drops nothing. */
  var releaseReason = 'dwell';

  function release() {
    if (released) return;
    released = true;
    if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
    EVENTS.forEach(function (n) { window.removeEventListener(n, onInput, true); });
    schedule();
  }

  function onInput(ev) {
    if (ev && ev.isTrusted) {
      releaseReason = 'input:' + String(ev.type || '?');
      release();
    }
  }
  var EVENTS = ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'wheel', 'scroll'];
  EVENTS.forEach(function (n) { window.addEventListener(n, onInput, true); });

  function startDwell() {
    if (released || dwellTimer) return;
    visibleSince = Date.now();
    dwellTimer = setTimeout(release, Math.max(0, DWELL_MS - dwelled));
  }
  function pauseDwell() {
    if (released || !dwellTimer) return;
    clearTimeout(dwellTimer); dwellTimer = null;
    dwelled += Date.now() - visibleSince;
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') startDwell(); else pauseDwell();
  });
  if (document.visibilityState === 'visible') startDwell();

  window.addEventListener('pagehide', function () { if (released) send(true); }, { capture: true });
  document.addEventListener('visibilitychange', function () {
    if (released && document.visibilityState === 'hidden') send(true);
  });
})();
